import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Scrollbars from "react-custom-scrollbars-2";
import { Row, Col } from "reactstrap";

const DataTable = ({ items, columns, selectRow, pagination, height, customizedIndex }) => {
  //   const columns = [];
  let data = [];

  if (customizedIndex) {
    if (items?.length > 0) {
      // Object.keys(items?.[0]).forEach((key) => {
      //   if (items?.[0][key] !== null && typeof items?.[0][key] !== "object") {
      //     columns.push({ dataField: key, text: key.charAt(0).toUpperCase() + key.slice(1) });
      //   }
      // });
      data = items?.map((data, index) => {
        return { index, ...data };
      });
    }
  } else {
    if (items?.length > 0) {
      // Object.keys(items?.[0]).forEach((key) => {
      //   if (items?.[0][key] !== null && typeof items?.[0][key] !== "object") {
      //     columns.push({ dataField: key, text: key.charAt(0).toUpperCase() + key.slice(1) });
      //   }
      // });
      data = items?.map((data, index) => {
        return { index, ...data };
      });
    }
  }

  //
  //

  return (
    <Col className={"py-1 m-0 mb-2 col-12"} style={{ height: `${height}` }}>
      {items?.length > 0 ? (
        <Scrollbars>
          <BootstrapTable
            bootstrap4
            striped
            hover
            keyField="index"
            noDataIndication="No data to be shown!"
            data={data}
            columns={columns}
            bordered={true}
            classes="table-sm fs--1 border-bottom border-right border-200 mb-0 table-dashboard-th-nowrap bg-white"
            rowClasses="btn-reveal-trigger border-top border-200"
            headerClasses="bg-200 text-900 border-y border-200 position-sticky top-0"
            selectRow={selectRow}
          />
        </Scrollbars>
      ) : (
        "No data to be shown!"
      )}
    </Col>
  );
};

export default DataTable;
